<div style='margin-top:-80px; position:absolute; z-index: 11;' ngClass.lt-sm='no-gap'>
    
  <section ngClass.gt-xs='top-section-desktop' ngClass.lt-sm='top-section-mobile'>
    <div ngClass.gt-xs='top-section-desktop-filter' ngClass.lt-sm='top-section-mobile-filter' fxLayout='column' fxLayoutAlign='space-around center' fxLayoutGap.xs='20px' fxLayoutAlign.xs='start center'>
      <div fxHide fxShow.xs style='padding-top:20px'>
        <img src='/assets/images/all-white-logo.png' height='35px'>
      </div>
      <div ngClass.gt-xs='top-section-desktop-text' ngClass.lt-sm='top-section-mobile-text'>
          Imagine eliminating messy spreadsheets, scorecards and emails!
      </div>
      <div fxLayout.gt-xs='row' fxLayout.xs='column' fxLayoutAlign.gt-xs='center start' fxLayoutAlign.xs='center center'>
        <div ngClass.gt-xs='top-section-desktop-video' ngClass.lt-sm='top-section-mobile-video' fxFlex='1 1 55%'>
          <video width='100%' autobuffer controls id='videoPlayer' #videoPlayer>
            <source src="/assets/videos/s18-intro2.mp4" type="video/mp4"> Your browser does not support HTML5 video.
          </video>
          <div *ngIf='!autoplay' class='video-action-panel' fxLayout='column' fxLayoutAlign='center center' fxLayoutGap='35px'>
            <img src='/assets/images/white-green-logo.png' width='75%'>
            <button mat-raised-button class='s18-raised-button' (click)='playVideo()'>PLAY VIDEO</button>
          </div>
        </div>
        <div fxLayout='column' ngClass.gt-xs='top-section-desktop-testimonial' ngClass.lt-sm='top-section-mobile-testimonial' fxFlex='1 1 45%' fxHide.xs fxLayoutAlign='start center'>
          <div class='title title-desktop'>
              Get the power of real-time tournament management 
              in the palm of your hand.
              
          </div>
          <div ngClass.gt-md='testimonial-circle' ngClass.lt-lg='testimonial-circle-laptop' fxLayout='column' fxLayoutAlign='center center' fxLayoutGap='20px'>
            <div ngClass.gt-md='testimonial-title' ngClass.lt-lg='testimonial-title-laptop'>Software was exceptional!</div>
            <div ngClass.gt-md='testimonial-text' ngClass.lt-lg='testimonial-text-laptop'>
              "... we are once again looking forward to having your software make scoring on our trip a breeze! "
            </div>
            <div ngClass.gt-md='testimonial-title' ngClass.lt-lg='testimonial-title-laptop'>
              The WAB Crew
            </div>
          </div>
          <div ngClass.gt-md='testimonial-button' ngClass.lt-lg='testimonial-button-laptop' fxHide.xs>
            <button mat-raised-button class='orange-button'  ngClass.gt-md='small' ngClass.lt-lg='mobile' (click)='showRegistrationDialog()'>TRY IT FREE</button>
          </div>
        </div>
      </div>
      <div fxHide fxShow.xs class='title title-mobile' style='text-align:center;padding:20px;'>
          Get the power of real-time tournament management 
          in the palm of your hand.
      </div>
      <div fxHide fxShow.xs class='mobile-as-used' fxFlex='1 1 100%' fxFill fxLayout='column' fxLayoutAlign='center center' fxLayoutGap='10px'>
        <div class='current-user'>CURRENT USERS</div>
        <div class='user-count'>{{ userCount | number }}</div>
        <div class='counting'>... and counting!</div>
        <button mat-raised-button class='orange-button mobile' (click)='showRegistrationDialog()'>TRY IT FREE</button>
      </div>
  </div>
  </section>
  
  <section fxLayout='row' class='how-it-works' fxLayoutAlign='center center' id='howitworks' #howitworks>
    <div class='how-it-works-text'>
      HOW IT WORKS
    </div>
  </section>
  <section ngClass.gt-xs='how-to-desktop' ngClass.lt-sm='how-to-mobile' fxLayout='column'>

    <div fxLayout='row' fxLayoutAlign='center stretch'>
      <div class='how-to-picture' fxFlex='1 1 50%' fxHide.xs>
        <img src='/assets/images/step_one.png' width='100%'>
      </div>
      <div class='how-to-text' fxLayout='column' fxLayoutAlign='center center' fxFlex='1 1 50%' fxFlex.xs='1 1 100%'>
        <div class='how-to-title-defaults how-to-title'>
          STEP ONE
        </div>
        <div class='how-to-title-defaults how-to-sub-title'>
          CREATE YOUR LEAGUE
        </div>
        <div class='how-to-instructions'>
          <p>Here is the first step to golf greatness!</p>
          <ul>
            <li>Login to golfgameskeeper.com or create a new account</li>
            <li>Click the 'Leagues & Groups' tab</li>
            <li>Click the 'New League' button</li>
          </ul>
        </div>
        <button mat-raised-button class='orange-button small' (click)='showRegistrationDialog()'>TRY IT FREE</button>

      </div>
    </div>
    <div fxLayout='row' fxLayoutAlign='center stretch'>
      <div class='how-to-text' fxLayout='column' fxLayoutAlign='center center' fxFlex='1 1 50%' fxFlex.xs='1 1 100%'>
        <div class='how-to-title-defaults how-to-title'>
          STEP TWO
        </div>
        <div class='how-to-title-defaults how-to-sub-title'>
          NAME YOUR LEAGUE
        </div>
        <div class='how-to-instructions' style='text-align:center'>
          <p>Will you be the "Golf Fathers" or "Weapons of Grass Destruction?!"</p>
          <P>
            After you have your league name down, determine your golf season length. (sorry, forever isn't currently an option but we
            are working on it!)
          </P>
        </div>
        <button mat-raised-button class='orange-button small' (click)='showRegistrationDialog()'>TRY IT FREE</button>

      </div>
      <div class='how-to-picture' fxFlex='1 1 50%' fxHide.xs>
        <img src='/assets/images/step_two.png' width='100%'>
      </div>
    </div>
    <div fxLayout='row' fxLayoutAlign='center stretch'>
      <div class='how-to-picture' fxFlex='1 1 50%' fxHide.xs>
        <img src='/assets/images/step_three.png' width='100%'>
      </div>
      <div class='how-to-text' fxLayout='column' fxLayoutAlign='center center' fxFlex='1 1 50%' fxFlex.xs='1 1 100%'>
        <div class='how-to-title-defaults how-to-title'>
          STEP THREE
        </div>
        <div class='how-to-title-defaults how-to-sub-title'>
          ADD YOUR PLAYERS
        </div>
        <div class='how-to-instructions'>
          <p>So Golf Father - Who is part of the gang? It's time to add your players.</p>
          <p>Here is how:</p>
          <ul>
            <li>Click on the 'Players' tab, and determine the best method to load your Players
              <ul>
                <li>One at a time</li>
                <li>Batch upload</li>
                <li>Add players from other groups (if you have multiple leagues)</li>
              </ul>
            </li>
          </ul>
        </div>
        <button mat-raised-button class='orange-button small' (click)='showRegistrationDialog()'>TRY IT FREE</button>

      </div>

    </div>
    <div fxLayout='row' fxLayoutAlign='center stretch'>
      <div class='how-to-text' fxLayout='column' fxLayoutAlign='center center' fxFlex='1 1 50%' fxFlex.xs='1 1 100%'>
        <div class='how-to-title-defaults how-to-title'>
          STEP FOUR
        </div>
        <div class='how-to-title-defaults how-to-sub-title'>
          CREATE YOUR EVENT
        </div>
        <div class='how-to-instructions'>
          <p>Let's par-tee! It's time to create your event.</p>
          <ul>
            <li>Click on the 'Events' tab</li>
            <li>Click on the 'New Event' button</li>
            <li>Answer the basic event questions</li>
            <li>Click 'Create Event'</li>
          </ul>
        </div>
        <button mat-raised-button class='orange-button small' (click)='showRegistrationDialog()'>TRY IT FREE</button>

      </div>
      <div class='how-to-picture' fxFlex='1 1 50%' fxHide.xs>
        <img src='/assets/images/step_four.png' width='100%'>
      </div>
    </div>
    <div fxLayout='row' fxLayoutAlign='center stretch'>
      <div class='how-to-picture' fxFlex='1 1 50%' fxHide.xs>
        <img src='/assets/images/step_five.png' width='100%'>
      </div>
      <div class='how-to-text' fxLayout='column' fxLayoutAlign='center center' fxFlex='1 1 50%' fxFlex.xs='1 1 100%'>
        <div class='how-to-title-defaults how-to-title'>
          STEP FIVE
        </div>
        <div class='how-to-title-defaults how-to-sub-title'>
          TRACK PLAYER SCORES
        </div>
        <div class='how-to-instructions' style='text-align:center'>
          <p>After your league is set up, it’s time to play!</p>
          <p>With our easy-to-use app, you can keep the score error free while on the course. (Pencil and paper not included.
            Thank goodness!)
          </p>
          <p>View real-time leader boards on the app or mirror it on a large screen TV.
          </p>
          <p>May the course be with you!
          </p>
        </div>
        <button mat-raised-button class='orange-button small' (click)='showRegistrationDialog()'>TRY IT FREE</button>

      </div>
    </div>
  </section>
  <s18-kick-putt *ngIf='showHeader'></s18-kick-putt>
  <section ngClass.gt-xs='top-section-desktop' ngClass.lt-sm='top-section-mobile' fxHide.xs>
    <div class='top-section-desktop-filter' fxLayout='column' fxLayoutAlign='center center' fxLayoutGap='150px'>
      <div class='bottom-section-text'>
        ALL-IN-ONE DIGITAL GOLF LEAGUE MANAGEMENT
      </div>
      <div>
        <button mat-raised-button class='orange-button big' (click)='showRegistrationDialog()'>TRY IT FREE</button>
      </div>
    </div>
  </section>
  <a href='/privacy'>Privacy Policy</a>
</div>